<mat-dialog-content>
  <form class="w-100 display-flex flex-column grid-gap-16" [formGroup]="form">
    <div class="w-100 display-flex flex-column grid-gap-6">
      <app-input
        formControlName="name"
        [attrPlaceholder]="'Enter view name'"
        [attrLabel]="'Name'"
        [attrDisable]="!hasEditPermission"
        [labelRequired]="true"
        [showValidationError]="true"
        [errorSection]="false"
        class="w-100"></app-input>

      <div class="notification display-flex align-items-center grid-gap-6">
        <div class="display-flex flex-column align-items-center justify-content-center content-warning-icon grid-gap-1">
          <div class="content-warning-icon-line"></div>
          <div class="content-warning-icon-dot"></div>
        </div>

        <span *ngIf="form?.value?.dataSource != null">
          Type: {{ getDataSourceType(form.value.dataSource) }}. To change the type, please contact support
        </span>
      </div>
    </div>

    <div class="w-100 display-flex flex-column">
      <div class="w-100 display-flex grid-gap-16">
        <app-radio-button-dropdown
          formControlName="rolesCanView"
          [labelRequired]="true"
          [showValidationError]="true"
          [errorSection]="false"
          class="flex-1"
          [items]="roles$ | async"
          [label]="'Who can see the view'"
          [labelCss]="'label-standard-font-size'"
          [attrPlaceholder]="'Select roles'"
          [itemPlaceholder]="'role'"
          [allowClear]="true"
          [allowSearch]="(roles$ | async)?.length > 7"
          [multiSelect]="true"
          [allowSelectAll]="true"
          [attrDisable]="!hasEditPermission"
          attrAppendTo="body"></app-radio-button-dropdown>

        <app-radio-button-dropdown
          formControlName="rolesCanEdit"
          class="flex-1"
          [items]="roles$ | async"
          [label]="'Who can edit the view'"
          [labelCss]="'label-standard-font-size'"
          [attrPlaceholder]="'Select roles'"
          [itemPlaceholder]="'role'"
          [allowClear]="true"
          [allowSearch]="(roles$ | async)?.length > 7"
          [multiSelect]="true"
          [allowSelectAll]="true"
          [attrDisable]="!hasEditPermission"
          attrAppendTo="body"></app-radio-button-dropdown>
      </div>
    </div>

    <div class="w-100 display-flex flex-column grid-gap-6">
      <app-radio-button-dropdown
        formControlName="defaultForRoles"
        [showValidationError]="true"
        [errorSection]="false"
        [items]="roles$ | async"
        [label]="'Set as default for'"
        [labelCss]="'label-standard-font-size'"
        [attrPlaceholder]="'Select roles'"
        [itemPlaceholder]="'role'"
        [allowClear]="true"
        [allowSearch]="(roles$ | async)?.length > 7"
        [multiSelect]="true"
        [allowSelectAll]="true"
        [attrDisable]="!hasEditPermission"
        attrAppendTo="body"></app-radio-button-dropdown>

      <div class="notification display-flex align-items-center grid-gap-6">
        <div class="display-flex flex-column align-items-center justify-content-center content-warning-icon grid-gap-1">
          <div class="content-warning-icon-line"></div>
          <div class="content-warning-icon-dot"></div>
        </div>

        <span *ngIf="form?.value?.dataSource != null">
          Saving a new default view for a role will replace its current default view
        </span>
      </div>
    </div>

    <app-input-area
      class="w-100"
      [label]="'Description'"
      [inputCss]="'hp-92'"
      [labelCss]="'body-small-bold nowrap'"
      [containerCss]="'fill body-small'"
      formControlName="description"
      [attrPlaceholder]="
        'Enter a description to display in the ' + getSummaryLabel(form.value.summaryType) + ' settings list'
      "
      [displayCounter]="true"
      [attrDisable]="!hasEditPermission"
      [inputDisabled]="!hasEditPermission"
      [maxCounter]="1000"></app-input-area>

    <div *ngIf="configDescription" class="config-container display-flex flex-column grid-gap-4">
      <span class="text-config text-config-title">Selected Configuration:</span>
      <span *ngIf="configDescription?.viewBy">{{ configDescription.viewBy }}</span>
      <span *ngIf="configDescription?.periodBy">
        <span class="text-config">{{ configDescription.periodBy.periodTitle }}:</span>
        {{ configDescription.periodBy.periodBy }}
        {{
          configDescription.periodBy?.periodBy?.toLowerCase() === 'custom' &&
          configDescription.periodBy?.startDate &&
          configDescription.periodBy?.endDate
            ? '(' + configDescription.periodBy.startDate + ' — ' + configDescription.periodBy.endDate + ')'
            : ''
        }}
      </span>
      <span>
        <span class="text-config">Show By:</span>
        {{ configDescription?.showBy ? configDescription.showBy : 'no Show By selected' }}
      </span>
      <span>
        <span class="text-config">Filter By:</span>
        {{ configDescription?.filterBy ? configDescription.filterBy : 'no Filter By selected' }}
      </span>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions class="display-flex justify-content-end grid-gap-16">
  <button class="summary-storage-modal-button" mat-stroked-button color="warn" (click)="cancel()" [disabled]="isSaving">
    Cancel
  </button>
  <button
    class="summary-storage-modal-button"
    mat-raised-button
    color="primary"
    (click)="save()"
    [disabled]="isSaving || !hasEditPermission">
    <div class="display-flex align-items-center grid-gap-8">
      <mat-progress-spinner *ngIf="isSaving" diameter="30" color="primary" mode="indeterminate"></mat-progress-spinner>
      <span>{{ data.saveAsNew ? 'Save as new' : 'Save' }}</span>
    </div>
  </button>
</mat-dialog-actions>
